const colors = {
  background: "#F9FAFC",
  label: "#2F2F2F",
  inputBorder: "#70707048",
  primary: "#436EE0",
}

export default colors
